import { useEffect, useState } from "react";

const COLORS = ["#ec4899", "#f472b6", "#d946ef", "#fb7185", "#a855f7", "#f9a8d4"];

// Small pink/fuchsia confetti burst. Re-triggers whenever `fire` changes to a new truthy value.
export default function ConfettiBurst({ fire }) {
  const [parts, setParts] = useState([]);

  useEffect(() => {
    if (!fire) return;
    const n = 16;
    const arr = Array.from({ length: n }, (_, i) => {
      const ang = (Math.PI * 2 * i) / n + (Math.random() - 0.5) * 0.5;
      const dist = 24 + Math.random() * 28;
      return {
        id: `${fire}-${i}`,
        dx: Math.cos(ang) * dist,
        dy: Math.sin(ang) * dist - 8,
        rot: Math.floor(Math.random() * 360),
        color: COLORS[i % COLORS.length],
        delay: Math.floor(Math.random() * 70),
      };
    });
    setParts(arr);
    const t = setTimeout(() => setParts([]), 900);
    return () => clearTimeout(t);
  }, [fire]);

  if (!parts.length) return null;

  return (
    <div
      aria-hidden="true"
      className="absolute left-1/2 top-1/2 pointer-events-none z-20"
      style={{ transform: "translate(-50%, -50%)" }}
    >
      {parts.map((p) => (
        <span
          key={p.id}
          className="tp-confetti-piece"
          style={{
            "--dx": `${p.dx}px`,
            "--dy": `${p.dy}px`,
            "--rot": `${p.rot}deg`,
            background: p.color,
            animationDelay: `${p.delay}ms`,
          }}
        />
      ))}
    </div>
  );
}
